let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kmFmA")).then(() => parcelRequire('7MfGI'));